import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["$hovered", "$cssStyles", "aria-disabled", "$detached", "$styleOverrides"],
  _excluded2 = ["IconHolder", "icon", "iconSize", "hovered", "aria-label", "onClick", "onMouseDown", "aria-disabled", "title", "aria-hidden", "role", "id", "aria-describedby", "detached"];
import styled from 'foundations-theming/utils';
import { rgba } from '../../utils/color';
import { HoverProvider } from '../HoverProvider/HoverProvider';
import { setUiTransition } from '../../utils/styles/styles';
import { Clickable } from '../Clickable/Clickable';
import { IconHolder as IconHolderComponent } from '../IconHolder/IconHolder';
import { useCloseButtonContext } from '../CloseButton/CloseButtonProvider';
import { deepMerge } from '../../utils/deepMerge/deepMerge';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { MERCURY_LAYER } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDialogButton = styled(_ref => {
  let {
      'aria-disabled': ariaDisabled
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Clickable, Object.assign({
    disabled: ariaDisabled
  }, rest));
})(({
  $hovered,
  $cssStyles,
  theme,
  $detached,
  $styleOverrides
}) => {
  return deepMerge(deepMerge(Object.assign({}, setUiTransition('color'), {
    alignItems: 'center',
    color: $detached && $hovered ? theme.color['text-core-default'] : theme.color['text-interactive-on-fill-default'],
    display: 'flex',
    flexShrink: '0',
    justifyContent: 'center',
    lineHeight: 'normal',
    position: 'relative',
    zIndex: MERCURY_LAYER,
    '&::after': Object.assign({}, setUiTransition('background'), {
      background: $detached || !$detached && $hovered ? theme.color['fill-inverse-hover-transparent'] : undefined,
      borderRadius: theme.borderRadius['full'],
      content: "' '",
      insetInlineStart: '50%',
      paddingBlock: theme.space['500'],
      paddingInline: theme.space['500'],
      position: 'absolute',
      insetBlockStart: '50%',
      transform: 'translate(-50%, -50%)'
    }),
    "&[aria-disabled='true']": {
      background: rgba(theme.color['fill-surface-default'], 0.08),
      cursor: 'not-allowed'
    }
  }), $styleOverrides), $cssStyles);
});
export function DialogButton(_ref2) {
  let {
      IconHolder = IconHolderComponent,
      icon,
      iconSize = '300',
      hovered,
      'aria-label': ariaLabel,
      onClick,
      onMouseDown,
      'aria-disabled': ariaDisabled,
      title,
      'aria-hidden': ariaHidden,
      role,
      id,
      'aria-describedby': ariaDescribedby,
      detached
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const closeButtonContext = useCloseButtonContext();
  return /*#__PURE__*/_jsx(HoverProvider, {
    hovered: hovered,
    children: hoverProviderProps => {
      var _closeButtonContext$d;
      const hoverAttributes = Object.assign({}, hoverProviderProps);
      delete hoverAttributes.hovered; // 'hovered' is not an HTML attribute, so we don't want to pass it to the `StyledDialogButton`

      return /*#__PURE__*/_jsx(StyledDialogButton, Object.assign({}, domProps, {
        "aria-label": ariaLabel,
        onClick: onClick,
        onMouseDown: onMouseDown,
        "aria-disabled": ariaDisabled,
        title: title,
        "aria-hidden": ariaHidden,
        role: role,
        id: id,
        "aria-describedby": ariaDescribedby
      }, hoverAttributes, {
        $hovered: hoverProviderProps.hovered,
        $cssStyles: cssStyles,
        $styleOverrides: (_closeButtonContext$d = closeButtonContext === null || closeButtonContext === void 0 ? void 0 : closeButtonContext.dialogButtonStyleOverrides) !== null && _closeButtonContext$d !== void 0 ? _closeButtonContext$d : {},
        $detached: detached,
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: icon,
          padding: "0",
          size: iconSize
        })
      }));
    }
  });
}